/* eslint-disable radix */

/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_PROMOTION_URL, COMMON_HEADER_CONFIG} from "../config";

class PromotionService {
  getAccessToken = () => localStorage.getItem("accessToken");

  parseFieldsToInt = (promotion) => {
    const fieldNames = [
      "max_size",
      "customer_size",
      "value",
      "max_price_discount",
      "min_order_price"
    ];
    fieldNames.forEach((field) => {
      promotion[field] = parseInt(promotion[field]);
    });
  };

  searchPromotions = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_PROMOTION_URL}/promotion`,
        params: {
          limit: 100,
          page: 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getPromotions = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_PROMOTION_URL}/promotion`,
        params: {
          limit: 100,
          page: 1
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createPromotion = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = data;
      this.parseFieldsToInt(dataCreate);
      const config = {
        method: "post",
        url: `${API_PROMOTION_URL}/promotion`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updatePromotion = (data, id) =>
    new Promise((resolve, reject) => {
      const dataUpdate = data;
      this.parseFieldsToInt(dataUpdate);
      const config = {
        method: "PUT",
        url: `${API_PROMOTION_URL}/promotion/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data: dataUpdate
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getPromotionById = (promotionId) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_PROMOTION_URL}/promotion/${promotionId}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deletePromotion = (promotionId) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_PROMOTION_URL}/promotion/${promotionId}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data.code === "success") {
            resolve(promotionId);
          } else {
            reject(response.data.code);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const promotionService = new PromotionService();

export default promotionService;
